import React from 'react'
import NotificationSystem from 'react-notification-system'

class Notification extends React.Component {

	constructor(props) { 
        super(props);
        this._notificationSystem = null
    }

    componentDidMount() {
      this._notificationSystem = this.refs.notificationSystem
    }

    componentWillReceiveProps(nextProps){

        if(nextProps.notification.notif.message){
    	   this._notificationSystem.addNotification(nextProps.notification.notif);
        }
    }

    render() {
    	const { provider } = this.props

    	
    	return (
    		<NotificationSystem ref="notificationSystem" />
    	)
    }
}

export default Notification


// WEBPACK FOOTER //
// ./src/notification/components/Notification.js